import * as z from "zod";
import { requiredString, requiredNumber } from "components/form/utils";

export const clientSchema = z.object({
  first_name: requiredString(),
  last_name: requiredString(),
  // client_id: z.string(),
  mobile_number: z.string().optional().nullable(),
  email: z
    .string()
    .email("Invalid email format")
    .optional()
    .or(z.literal(""))
    .nullable(),
  company_id: requiredString(),
  notes: z.string().optional().nullable(),
  about: z.string().optional().nullable(),
  job_title: z.union([z.string(), z.number()]).optional().nullable(),
  code: requiredString()
    .length(4, "Code must be exactly 4 characters")
    .transform((v) => (typeof v === "string" ? v.toUpperCase() : v)),
  // Stored as varchar in Directus, so saved values load as strings ("30")
  billable_due_days: z.preprocess(
    (v) => (typeof v === "string" && v.trim() !== "" ? Number(v) : v),
    requiredNumber(),
  ),
});
